import React from 'react'
import './Footer.css'

const Footer = () => {
    return (
        <div className="footer">
            <a className="icon" href="https://github.com/bera5186/React-Recipe-Search" target="_blank" rel="noopener noreferrer"><i className="fa fa-github fa-2x" aria-hidden="true"></i></a>
        </div>
    )
}

export default Footer